import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
  text?: string;
  delay?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  fullScreen = false,
  text = 'Loading...',
  delay = 0
}) => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-12 w-12',
    lg: 'h-16 w-16'
  };

  const borderSizes = {
    sm: 'border-2',
    md: 'border-4',
    lg: 'border-4'
  };

  const content = (
    <div className="flex flex-col items-center justify-center">
      <div className={`relative ${sizeClasses[size]}`}>
        <div className={`${sizeClasses[size]} ${borderSizes[size]} rounded-full border-gray-200`}></div>
        <div 
          className={`absolute top-0 left-0 ${sizeClasses[size]} ${borderSizes[size]} rounded-full border-emerald-600 border-t-transparent animate-spin`}
          style={{ animationDuration: '0.8s' }}
        ></div>
      </div>
      {text && (
        <p className="mt-4 text-gray-600 font-medium animate-pulse">{text}</p>
      )}
    </div>
  );

  // Add delay for better perceived performance
  const delayedContent = delay > 0 ? (
    <div style={{ animation: `fadeIn 0.3s ease-in-out ${delay}ms forwards`, opacity: 0 }}>
      {content}
    </div>
  ) : content;

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white/80 backdrop-blur-sm z-50 flex items-center justify-center">
        {delayedContent}
      </div>
    );
  }

  return <div className="flex items-center justify-center p-8">{delayedContent}</div>;
};

// Add fadeIn animation to index.css if not present
// You can add this to your index.css:
// @keyframes fadeIn {
//   from { opacity: 0; }
//   to { opacity: 1; }
// }

export default LoadingSpinner;